import { useEffect, useState } from "react";

// Light or dark. The page follows the device's setting until you pick one
// with the header button; your pick is remembered in this browser. A small
// script in public/index.html sets the theme before the page shows, so it
// doesn't flash white first.
const KEY = "partycade.theme";
const query = () => (typeof window !== "undefined" ? window.matchMedia?.("(prefers-color-scheme: dark)") : null);

export function savedTheme() {
  try {
    const t = localStorage.getItem(KEY);
    return t === "dark" || t === "light" ? t : null;
  } catch {
    return null;
  }
}

export const deviceTheme = () => (query()?.matches ? "dark" : "light");

export function useTheme() {
  const [saved, setSaved] = useState(savedTheme);
  const [device, setDevice] = useState(deviceTheme);
  const theme = saved || device;

  useEffect(() => {
    const q = query();
    if (!q?.addEventListener) return;
    const change = () => setDevice(q.matches ? "dark" : "light");
    q.addEventListener("change", change);
    return () => q.removeEventListener("change", change);
  }, []);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  // Picking the device's own theme goes back to following the device.
  const setTheme = (next) => {
    const keep = next === device ? null : next;
    try {
      if (keep) localStorage.setItem(KEY, keep);
      else localStorage.removeItem(KEY);
    } catch {}
    setSaved(keep);
  };

  return [theme, setTheme];
}
